<template>
    <section id="trackingRequestList" class="page-content">
        <main id="section-body">
            <div class="filters">
                <div class="filter">
                    <label>Search</label>
                    <div class="control">
                        <input class="input" type="text" @keyup.enter="getShipmentsFiltered()" placeholder="Search for shipments..."
                          v-model="filters.search" name="search" id="search">
                    </div>
                </div>
                <div class="filter">
                    <label>Shipments Health</label>
                    <health-filter :data="health" @change="filters.health = $event;health = $event; debouncedGetAnswer()"/>
                </div>
                <div class="filter">
                    <label>POL</label>
                    <div class="control">
                        <input class="input" type="text" @keyup.enter="getShipmentsFiltered()" placeholder="Search for POL..."
                        v-model="filters.pol_loc" name="pol_loc" id="pol_loc">
                    </div>
                </div>
                <div class="filter">
                    <label>POD</label>
                      <div class="control">
                        <input class="input" type="text" @keyup.enter="getShipmentsFiltered()" placeholder="Search for POD..."
                        v-model="filters.pod_loc" name="pod_loc" id="pod_loc">
                      </div>
                </div>
                <a class="filter-reset is-primary button is-small" @click="getShipmentsFiltered()">Load Results</a>
                <a class="filter-reset button is-small" @click="reset()">Reset</a>
            </div>
            <div class="n-containers">SHOWING <span class="total-number">{{shipments.length}}</span> CONTAINERS:</div>
            <spinner v-show="loadingList"></spinner>
            <gmap-map v-show="!loadingList" ref="gmap"
                :center="center"
                :zoom="2.2"
                :options="{minZoom: 2}"
                style="margin: auto; width:95%;  min-height: 70vh; border: 1px black solid; border-radius: 1em; overflow: hidden;"
            >
                <gmap-info-window  :position="place.last_coordinates" :opened="showInfo"
                @closeclick="showInfo=false" :options="{pixelOffset: {width: 0, height: -35}}">
                  <div v-if="!place.shipments">
                    <ul class="map-info" :class="place.health">
                      <li><b>BL / Booking: </b> {{place.bl_or_booking_number}}</li>
                      <li><b>Carrier: </b> {{place.carrier_name}}</li>
                      <li><b>Vessel: </b> {{place.current_vessel}}</li>
                      <li><b>C. Code: </b> {{place.client_code}}</li>
                      <li><b>Container: </b> {{place.container_number}}</li>
                      <li>
                        <b>LifeCycle Status: </b>
                        <span class="status-tag" :class="lifecycleColors[place.lifecycle_status_verbose]">
                          {{place.lifecycle_status_verbose}}
                        </span>
                      </li>
                      <li>
                        <b>Status: </b>
                        <span class="status-tag" :class="statusColors[place.status_verbose]">
                          {{place.status_verbose}}
                        </span>
                      </li>
                    </ul>
                    <div class="health-icon-container">
                      <i class="health-icon fa fa-3x" :class="`${healthIcons[place.health]} ${place.health}`" />
                    </div>
                    <div style="text-align:right">
                      <a :href="'shipments/' + place.id"><button style="height:2em" class="button is-primary">Detail</button></a>
                    </div>
                  </div>
                  <div v-else>
                    <div class="map-info-title">This marker contains <span :class="place.health">{{ place.shipments.length }}</span> shipments</div>
                    <div class="map-info" :class="place.health" style="max-height: 370px; overflow: auto">
                      <table class="table is-fullwidth is-striped is-bordered is-hoverable" style="font-size: .9em">
                        <thead>
                          <th colspan="2"> BL / Booking </th>
                          <th> Carrier </th>
                          <th> Vessel </th>
                          <th> C. Code </th>
                          <th> Container </th>
                          <th> LifeCycle Status </th>
                          <th> Status </th>
                        </thead>
                        <tbody>
                          <tr v-for="ship in place.shipments" :key="ship.id">
                            <td>
                              <i class="health-icon fa fa-1x" :class="`${healthIcons[ship.health]} ${ship.health}`" />
                            </td>
                            <td>
                              <router-link :to="'shipments/' + ship.id">
                                {{ ship.bl_or_booking_number }}
                              </router-link>
                            </td>
                            <td>
                              {{ ship.carrier_name }}
                            </td>
                            <td>
                              {{ ship.current_vessel.name }}
                            </td>
                            <td>
                              {{ ship.client_code }}
                            </td>
                            <td>
                              {{ ship.container_number }}
                            </td>
                            <td>
                              <span class="status-tag" :class="lifecycleColors[ship.lifecycle_status_verbose]">
                                {{ship.lifecycle_status_verbose}}
                              </span>
                            </td>
                            <td>
                              <span class="status-tag" :class="statusColors[ship.lifecycle_status_verbose]">
                                {{ship.status_verbose}}
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="health-icon-container">
                      <i class="health-icon fa fa-3x" :class="`${healthIcons[place.health]} ${place.health}`" />
                    </div>
                  </div>
                </gmap-info-window>
                <gmap-cluster
                :zoomOnClick="true"
                :maxZoom="4"
                :calculator="clusterCalculator"
                :styles="clusterStyles"
                >
                  <gmap-marker
                      v-if="m.last_coordinates"
                      :key="index"
                      :optimized="false"
                      :zIndex="index"
                      :label="m.shipments ? {
                        text: '' + m.shipments.length,
                        color: '#ffffff',
                        fontSize: '22px',
                        fontWeight: 'bold',
                        className: 'marker-label ' + m.health
                      }
                      :
                      undefined"
                      v-for="(m, index) in shipments"
                      :position="m.last_coordinates"
                      :icon="'/static/img/ship-' + m.health+ '.png'"
                      @click="setPlace(m)"
                      :clickable="true"
                  ></gmap-marker>
                </gmap-cluster>
            </gmap-map>
        </main>
    </section>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import HealthFilter from '@/components/HealthFilter'
import Spinner from '@/components/Spinner'
import _ from 'lodash'
export default {
  name: 'mapLocations',
  components: {HealthFilter, Spinner},
  created () {
    this.debouncedGetAnswer = _.debounce(this.getShipmentsFiltered, 500)
  },
  mounted () {
    this.$emit('loading')
    this.$refs.gmap.$mapPromise.then((map) => {
      // eslint-disable-next-line
      this.getShipmentsFiltered()
    }).then(() => { this.$emit('loaded') })
  },
  computed: {
    ...mapState({
    }),
    clusterStyles () {
      var sizes = [{ name: 'low', ico: 53 }, { name: 'medium', ico: 56 }, { name: 'high', ico: 66, text: 22 }, { name: 'extra-high', ico: 77, text: 25 }]
      var output = []
      var healths = ['ontrack', 'delayed', 'alerted']
      healths.forEach(health => {
        sizes.forEach(size => {
          output.push({
            height: size.ico,
            url: `/static/img/cluster-${health}-${size.name}4.png`,
            width: size.ico,
            textSize: size.text,
            textColor: '#ffffff'
          })
        })
      })
      return output
    }
  },
  data () {
    return {
      urlFilters: ['search', 'health', 'pol_loc', 'pod_loc'],
      filters: {},
      health: '',
      shipments: [],
      center: { lat: 45.508, lng: -73.587 },
      markerImg: '',
      currentPlace: null,
      place: {},
      showInfo: false,
      loadingList: false,
      healthIcons: {
        ontrack: 'fa-thumbs-up',
        delayed: 'fa-exclamation',
        alerted: 'fa-exclamation-triangle'
      },
      lifecycleColors: {
        active: 'blue',
        expired: 'red',
        'lifecycle completed': 'green'
      },
      statusColors: {
        'completed': 'black',
        'delivered; returning container': 'black',
        'in POD terminal': 'green',
        'in POL terminal': 'green',
        'in transshipment': 'green',
        'initializing': 'blue',
        'land transport to Place of Delivery': 'green',
        'land transport to POL': 'green',
        'ocean transport from POL': 'green',
        'ocean transport to POD': 'green',
        'unknown': 'grey',
        'waiting for departure from POL': 'orange',
        'waiting for discharge at POD': 'orange',
        'waiting for pickup': 'orange'
      }
    }
  },
  beforeMount: function () {
    // Load filters and page from URL query string
    Object.keys(this.$route['query']).forEach(key => {
      if (this.urlFilters.indexOf(key) >= 0) {
        this.filters[key] = this.$route['query'][key]
      }
    })
    if (this.filters.health) {
      this.health = this.filters.health
    }
  },
  methods: {
    ...mapActions({
      getCoordinates: 'shipment/coordinates'
    }),
    clusterCalculator (markers, numStyles) {
      var index = 0
      var count = markers.length
      var total = count
      var alerted = markers.filter((x) => x.icon.indexOf('alerted') > -1)
      var delayed = markers.filter((x) => x.icon.indexOf('delayed') > -1)
      while (total !== 0) {
        total = parseInt(total / 4, 10)
        index++
      }
      index = Math.min(index, numStyles)
      if (delayed.length > 0) {
        index += 4
      }
      if (alerted.length > 0) {
        index += 8
      }
      return {
        text: count,
        index: index // reference added style
      }
    },
    setURLQueryParams (filters) {
      var config = Object.assign({}, filters)
      Object.keys(config).forEach(key => {
        if (!config[key]) { delete config[key] }
      })
      this.$router.replace({ name: this.$route.name, query: config })
    },
    setPlace (place) {
      this.place = place
      this.showInfo = true
    },
    groupByCoordinates (array) {
      var groupedObj = array.reduce((accumulator, x) => {
        var key = 'null'
        if (x.last_coordinates) {
          key = `${x.last_coordinates.lat} - ${x.last_coordinates.lng}`
        }
        (accumulator[key] = accumulator[key] || []).push(x)
        return accumulator
      }, {})

      return Object.values(groupedObj).map((value) => {
        if (value.length === 1) {
          return {
            id: value[0].id,
            health: value[0].health,
            last_coordinates: value[0].last_coordinates,
            bl_or_booking_number: value[0].bl_or_booking_number,
            current_vessel: value[0].current_vessel.name,
            carrier_name: value[0].carrier_name,
            client_code: value[0].client_code,
            container_number: value[0].container_number,
            lifecycle_status_verbose: value[0].lifecycle_status_verbose,
            status_verbose: value[0].status_verbose
          }
        } else {
          var health = 'ontrack'
          if (value.filter((x) => x.health === 'delayed').length) health = 'delayed'
          if (value.filter((x) => x.health === 'alerted').length) health = 'alerted'
          return {
            last_coordinates: value[0].last_coordinates,
            health: health,
            shipments: value
          }
        }
      })
    },
    getShipmentsFiltered () {
      this.loadingList = true
      this.setURLQueryParams(this.filters)
      if (this.filters.health) {
        this.health = this.filters.health
      }
      return this.getCoordinates(this.filters).then((response) => {
        var groups = this.groupByCoordinates(response)
        this.shipments = groups
        this.loadingList = false
        // eslint-disable-next-line
        var bounds = new google.maps.LatLngBounds()
        this.shipments.forEach(ship => {
          if (ship.last_coordinates) {
            bounds.extend(ship.last_coordinates)
          }
        })
        return this.$refs.gmap.$mapPromise.then((map) => {
          // eslint-disable-next-line
          google.maps.event.addListener(map, 'zoom_changed', () => {
            var zoomChangeBoundsListener =
              // eslint-disable-next-line
              google.maps.event.addListener(map, 'bounds_changed', (event) => {
                if (map.getZoom() > 8 && map.initialZoom) {
                  // Change max/min zoom here
                  map.setZoom(8)
                  map.initialZoom = false
                }
                // eslint-disable-next-line
                google.maps.event.removeListener(zoomChangeBoundsListener)
              })
          })
          map.initialZoom = true
          map.fitBounds(bounds)
        })
      })
    },
    reset () {
      this.filters = {}
      this.health = ''
      this.getShipmentsFiltered()
    }
  },
  watch: {
  }
}
</script>
<style lang="scss" scoped>

.modal-container{
  overflow: auto;
  max-height: 95vh;
}

.n-containers{
  display: block;
  padding-left: 1.5em;
  font-size: 1.2em;
  .total-number {
    color: rgb(0, 157, 151);
    font-weight: bold;
  }
}
.status-tag {
  padding: .4em .7em .4em .4em;
  font-weight: 900;
  text-transform: capitalize;
}
.map-info {
  border-radius: .4em;
  border: solid black 3px;
  padding: .5em 1em 2em;
  &.delayed {
    border-color: #ffb346;
  }
  &.ontrack {
    border-color: #90be6f;
  }
  &.alerted {
    border-color: #e73857;
  }
  li{
    padding: .2em 0;
  }
}
.health-icon-container {
  text-align: center;
  margin-top: -2em;
  i {
    text-shadow: 2px 0 #fff, -2px 0 #fff, 0 2px #fff, 0 -2px #fff,
              4px 0 #fff, -4px 0 #fff, 0 4px #fff, 0 -4px #fff,
              3px 3px #fff, -3px -3px #fff, 3px -3px #fff, -3px 3px #fff,
              2px 2px #fff, -2px -2px #fff, 2px -2px #fff, -2px 2px #fff,
              1px 1px #fff, -1px -1px #fff, 1px -1px #fff, -1px 1px #fff;
  }
}
.health-icon{
  &.delayed {
      color: #ffb346;
    }
    &.ontrack {
      color: #90be6f;
    }
    &.alerted {
      color: #e73857;
    }
}
.map-info-title {
  font-family: MuseoSans-700;
  font-size: 1.3em;
  .delayed {
    color: #ffb346;
  }
  .ontrack {
    color: #90be6f;
  }
  .alerted {
    color: #e73857;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/PageMapLocations.vue